import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../infrastructure/api/client";
import { ApiError, type DashboardStats } from "@tabipla/shared";

export function useDashboard() {
  return useQuery({
    queryKey: ["dashboard", "stats"],
    queryFn: async () => {
      const response = await apiClient.get<DashboardStats>("/api/dashboard/stats");
      if (!response.success) {
        throw ApiError.fromResponse(response.error, "Failed to fetch dashboard stats");
      }
      return response.data!;
    },
  });
}
